import React from "react";
import PropTypes from "prop-types";

/**
 * Format version array into readable string
 */
const formatVersion = (versionArray) => {
  if (!Array.isArray(versionArray)) return "";
  return versionArray.join(", ");
};

/**
 * Transform record.libloom into table data
 */
export const getLibloomData = (record) =>
  (record.libloom || []).map((item, index) => ({
    id: index,
    package: item.package,
    name: item.name,
    version: formatVersion(item.version),
  }));

/**
 * Table columns
 */
export const libloomColumns = [
  {
    Header: "Name",
    accessor: "name",
  },
  {
    Header: "Package",
    accessor: "package",
  },
  {
    Header: "Version",
    accessor: "version",
  },
];

export const libloomTitle = "category-title-libloom";